import * as moment from "moment-timezone";
import "moment/locale/es";

const PARSE_FORMATS = [
  "DD-MM-YYYY",
  "DD/MM/YYYY",
  "YYYY-MM-DD",
  "YYYY/MM/DD",
];

/**
 * Fecha legible en tablas de nómina: `28 abr 2026`.
 * Acepta DD-MM-YYYY, DD/MM/YYYY o YYYY-MM-DD.
 */
export function formatPayrollDisplayDate(fecha: string): string {
  if (!fecha?.trim()) {
    return fecha ?? "";
  }

  const parsed = moment(fecha, PARSE_FORMATS, true);
  const m = parsed.isValid() ? parsed : moment(fecha);
  if (!m.isValid()) {
    return fecha;
  }

  return m
    .locale("es")
    .format("D MMM YYYY")
    .replace(/\b([a-záéíóúñ]+)\./gi, "$1");
}

/** Variante corta para celdas estrechas: `15 abr`. */
export function formatPayrollDisplayDateShort(fecha: string): string {
  if (!fecha?.trim()) {
    return fecha ?? "";
  }

  const parsed = moment(fecha, PARSE_FORMATS, true);
  const m = parsed.isValid() ? parsed : moment(fecha);
  if (!m.isValid()) {
    return fecha;
  }

  return m
    .locale("es")
    .format("D MMM")
    .replace(/\b([a-záéíóúñ]+)\./gi, "$1");
}
